import { css, SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";

export const ContentContainer = styled("div")`
  ${({ theme }): SerializedStyles => css`
    ${theme.cssMixins.colVCentered};
  `}
`;
